import { useLingui } from '@lingui/react/macro';
import React from 'react';
import { ClipLoader } from 'react-spinners';
import UDText from 'ud-ui/components/text';

/**
 * Пока проверяется сохранённый вход (около секунды): вместо пустой карточки — что происходит.
 * Скелетон кита только светлый и на тёмной карточке входа резал бы глаз; для ожидания до
 * 10 секунд индикатор активности уместен (NN/g, «Skeleton Screens 101»). Спиннер — тот же
 * `ClipLoader`, что у кита (`UDAsyncContent`, `UDIconButton`), цвет — от текста.
 */
const AuthSessionPending = () => {
  const { t } = useLingui();

  return (
    <div role="status" className="text-inkOnDark flex items-center gap-3">
      <ClipLoader size={20} color="currentColor" aria-hidden />
      <UDText type="callout" className="text-inkOnDark">
        {t`Проверяем вход…`}
      </UDText>
    </div>
  );
};

export default AuthSessionPending;
